import { render, staticRenderFns } from "./PaymentDepositAccounts.vue?vue&type=template&id=641f08ec&scoped=true&"
import script from "./PaymentDepositAccounts.vue?vue&type=script&lang=js&"
export * from "./PaymentDepositAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDepositAccounts.vue?vue&type=style&index=0&id=641f08ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f08ec",
  null
  
)

export default component.exports